module.exports = __webpack_public_path__ + "static/img/mySQL.5c1e106.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/mySQL.svg
// module id = bFXY
// module chunks = 2